var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"collapse":_vm.isSidebarNavCollapse,"background-color":"#304156","text-color":"#eee","active-text-color":"#4dbcff","default-active":_vm.currentMenu}},[_c('DynamicMenu',{attrs:{"menuList":_vm.sidebarMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }